<script setup lang="ts">
import { computed } from 'vue'
import type { FairPaginationSegmentKind } from '@/ui/tokens/fair-pagination-bar.data'

interface FairPaginationSegmentProps {
  kind?: FairPaginationSegmentKind
  active?: boolean
  interactive?: boolean
  ariaLabel?: string
}

const props = withDefaults(defineProps<FairPaginationSegmentProps>(), {
  kind: 'center',
  active: false,
  interactive: true,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const rootClass = computed(() => ({
  'fair-pagination-segment': true,
  [`fair-pagination-segment--${props.kind}`]: true,
  'fair-pagination-segment--active': props.active,
  'fair-pagination-segment--disabled': !props.interactive,
}))

function handleClick(event: MouseEvent) {
  if (!props.interactive) {
    return
  }
  emit('click', event)
}
</script>

<template>
  <button
    type="button"
    :class="rootClass"
    :aria-label="ariaLabel"
    :aria-current="active ? 'true' : undefined"
    @click="handleClick"
  >
    <span
      class="fair-pagination-segment__track"
      aria-hidden="true"
    />
  </button>
</template>
